import { render, staticRenderFns } from "./Implemento.vue?vue&type=template&id=dd16fc70"
import script from "./Implemento.vue?vue&type=script&lang=js"
export * from "./Implemento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports